module.exports = __webpack_public_path__ + "img/redeem_form2_th.2a0bd61d.png";